import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuizPopupComponent } from './quiz-popup.component';
import { MotesMediaModule } from '../motes-media/motes-media.module';
import { SvgIconModule } from '../svg-icon';
import { QuizCountDownModule } from '../quiz-count-down/quiz-count-down.module';
import { QuizProgressModule } from '../quiz-progress/quiz-progress.module';
import { QuizRewardListModule } from '../quiz-reward-list/quiz-reward-list.module';
import { MotesLoginModule } from '../../motes-login';

@NgModule({
    declarations: [QuizPopupComponent],
    imports: [
        CommonModule,
        MotesMediaModule,
        SvgIconModule,
        QuizCountDownModule,
        QuizProgressModule,
        QuizRewardListModule,
        MotesLoginModule
    ],
    exports: [QuizPopupComponent]
})
export class QuizPopupModule { }
